<div class="flex flex-col p-6">
  <!-- Header with icon, title, and close button -->
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center gap-3">
      <div class="shrink-0">
        <img src="/assets/icons/alert-icon.svg" alt="Alert Icon" class="w-8 h-8" />
      </div>
      @if (data.title) {
        <h2 class="text-xl font-bold text-[#1a2332]">{{ data.title }}</h2>
      }
    </div>
    <button
      (click)="close()"
      class="shrink-0 text-blue-600 hover:text-blue-800 transition-colors"
      aria-label="Cerrar"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Message -->
  <div class="text-base font-normal text-[#1a2332] mb-8 leading-relaxed whitespace-pre-line">
    {{ data.message }}
  </div>

  <!-- Button -->
  <button
    class="bg-[#1a2332] text-white border-none rounded-full px-6 py-3 text-base font-bold cursor-pointer w-full hover:bg-[#2a3342] active:bg-[#0a1322] transition-colors duration-300 flex items-center justify-center gap-2"
    (click)="onButtonClick()"
  >
    <span>{{ data.btnLabel || 'Entendido' }}</span>
    @if (data.btnUrl) {
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
        <polyline points="15 3 21 3 21 9"></polyline>
        <line x1="10" y1="14" x2="21" y2="3"></line>
      </svg>
    }
  </button>
</div>
